import {
  getHours, getMinutes, getYear, getMonth, getDate,
  getTime, format, addMonths,
} from 'date-fns'
import {
  isOpenDayForLocation as sharedIsOpenDayForLocation,
  getOpenDateTimeForDate as sharedGetOpenDateTimeForDate,
  nextOpenDayForLocation as sharedNextOpenDayForLocation,
  nextValidPickupTime as sharedNextValidPickupTime,
  isValidPickupDateTimeForLocation as sharedIsValidPickupDateTimeForLocation,
  PICKUP_INVALID_REASON,
} from 'ecom-shared'
import { ErrorMessages } from '../configs/errorMessages'

import { immerSet } from './useStore'

// Day/hours correctness now lives in ecom-shared/location-hours.js — the
// same module ecombackend uses to validate pickup time server-side — so
// the two can never silently disagree. This file keeps only the
// UI-specific bits: zustand setters and translating the shared module's
// {valid, reason} result into this app's existing Error-based contract.

export const isOpenDayForLocation = sharedIsOpenDayForLocation
export const getOpenDateTimeForDate = sharedGetOpenDateTimeForDate
export const nextOpenDayForLocation = sharedNextOpenDayForLocation

// The earliest pickup slot that's actually valid right now for this
// location — never a value isValidPickupDateTimeForLocation would itself
// reject. Use this for any "what should the picker default to" need
// instead of hand-rolling a guess (see PickupTime.js).
export const nextValidPickupTime = sharedNextValidPickupTime

export const tsPickupUpdate = dt => immerSet(state => {
  state.tsPickup = getTime(dt)
})

export const tsPickupUpdateDate = dateOnly => immerSet(state => {
  const dt = new Date(getYear(dateOnly), getMonth(dateOnly), getDate(dateOnly),
    getHours(state.tsPickup), getMinutes(state.tsPickup))
  state.tsPickup = getTime(dt)
})

export const isValidPickupDateTimeForLocation = (tsPickup, location) => {
  const result = sharedIsValidPickupDateTimeForLocation(tsPickup, location)
  if (result.valid) return tsPickup

  switch (result.reason) {
    case PICKUP_INVALID_REASON.OUT_OF_WORKING_DAYS:
      return new Error(ErrorMessages.OutOfWorkingDays +
        (result.nextOpenTs ? `. Next open day is: ${format(result.nextOpenTs, 'iiii, d/MM')}.` : ''))
    case PICKUP_INVALID_REASON.PICKUP_TIME_PASSED:
      return new Error(ErrorMessages.PickupTimePassed)
    case PICKUP_INVALID_REASON.OUT_OF_WORKING_HOURS:
    default:
      return new Error(ErrorMessages.OutOfWorkingHours)
  }
}

// 1 + 1 months max
export const calendarMaxDate = (dt) => addMonths(dt, 1)
